// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-grid-list__container{margin-right:-28px;margin-bottom:-10px}.czt-grid-list__item{position:relative;padding:0 10px 10px 0 !important}.czt-grid-list .czt-headline{text-shadow:none}.czt-grid-list .v-skeleton-loader,.czt-grid-list .v-skeleton-loader__image{height:100%}@media(min-width: 1008px){.czt-grid-list__container{margin-right:-33px;margin-bottom:-15px}.czt-grid-list__item{padding:0 15px 15px 0 !important}}", ""]);
// Exports
module.exports = exports;
